/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherSunIcon20Solid = forwardRef('WeatherSunIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11 1a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V1Z" }),
        React.createElement("path", { d: "M11 17a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z" }),
        React.createElement("path", { d: "M17.071 17.071a1 1 0 0 1-1.414 0l-1.414-1.414a1 1 0 0 1 1.414-1.414l1.414 1.414a1 1 0 0 1 0 1.414Z" }),
        React.createElement("path", { d: "M5.757 5.758a1 1 0 0 1-1.414 0L2.93 4.343A1 1 0 0 1 4.343 2.93l1.414 1.414a1 1 0 0 1 0 1.415Z" }),
        React.createElement("path", { d: "M15 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z" }),
        React.createElement("path", { d: "M19 11a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2h2Z" }),
        React.createElement("path", { d: "M3 11a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2h2Z" }),
        React.createElement("path", { d: "M17.071 2.93a1 1 0 0 1 0 1.413l-1.414 1.415a1 1 0 1 1-1.414-1.415l1.414-1.414a1 1 0 0 1 1.414 0Z" }),
        React.createElement("path", { d: "M5.757 14.243a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1-1.414-1.414l1.414-1.414a1 1 0 0 1 1.414 0Z" })));
});
